export const fetchLocaleField = (result, defaultField, frenchField) => {

  //Search and Replace for French fields, if applicable
  let frenchData = null;
  let defaultData = null;

  frenchData = result?.attributes?.[frenchField]?.length ? result?.attributes?.[frenchField] : null;
  defaultData = result?.attributes?.[defaultField]?.length ? result?.attributes?.[defaultField] : null;

  return window.Shopify.locale === "fr" && frenchData ? frenchData : defaultData;
}